// extracted by mini-css-extract-plugin
export default {"container":"ProcesRowDetails_container__l7fKR","stage":"ProcesRowDetails_stage__H-NdC","btn_zamknij":"ProcesRowDetails_btn_zamknij__G15Hi"};